// ============================================================================
// LE GLN D'UN MAGASIN — saisi à la Console quand on déclare le magasin.
//
// UTILITÉ : le GLN est le SEUL pivot de l'EDI. Un fichier de fournisseur part au magasin que son GLN désigne ; un GLN
// mal saisi à la déclaration rend le magasin introuvable pour tous ses fournisseurs. L'assistant de la Console et son
// serveur appliquent la MÊME règle — écrite deux fois, elle accepterait un jour d'un côté ce que l'autre refuse.
//
// ⚠️ LA CLÉ DE CONTRÔLE SE VÉRIFIE : un GLN est attribué par GS1, il porte toujours une clé juste. Un chiffre faux donne
//    une clé fausse, c'est ainsi qu'une faute de frappe se voit avant d'être enregistrée.
// ============================================================================
import { isValidGln } from '@orgazone/core-catalog';

/** Ce qui ne va pas dans le GLN saisi pour un magasin — `null` quand il peut s'enregistrer. */
export function storeGlnProblem(gln: string): string | null {
  const v = gln.trim();
  if (!/^\d{13}$/.test(v)) return 'Le GLN doit comporter 13 chiffres.';
  if (!isValidGln(v)) return 'Clé de contrôle du GLN invalide : vérifiez la saisie (le GLN est attribué par GS1).';
  return null;
}
